module.exports = __webpack_public_path__ + "img/offers.265792bd.png";